import { createSlice } from '@reduxjs/toolkit';
import { InfraManagementState } from './types';

export const initialState: InfraManagementState = {
  list: {},
  loading: false,
  error: ''
};

const localeSlice = createSlice({
  name: 'infraManagement',
  initialState,
  reducers: {
    fetchChannelList: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchChannelListSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    fetchChannelListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    postChannelContent: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    postChannelContentSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    postChannelContentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    putGenerateClientId: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    putGenerateClientIdSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    putGenerateClientIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    putUpdateChannelDomains: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    putUpdateChannelDomainsSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    putUpdateChannelDomainsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  fetchChannelList,
  fetchChannelListSuccess,
  fetchChannelListFailure,
  postChannelContent,
  postChannelContentSuccess,
  postChannelContentFailure,
  putGenerateClientId,
  putGenerateClientIdSuccess,
  putGenerateClientIdFailure,
  putUpdateChannelDomains,
  putUpdateChannelDomainsSuccess,
  putUpdateChannelDomainsFailure,
  resetState
} = localeSlice.actions;

export default localeSlice.reducer;
